import { OptionType } from 'Components/molecules/ChipMultiSelect/ChipMultiSelect';
import { sourceMeta } from '../InventoryGrid/sourceMeta';
import { GoTag } from '@react-icons/all-files/go/GoTag';

/** Chip/dropdown option for a tag spec — same icon treatment as finding tag pills (SourcePillsList). */
export function tagNameToChipOption(tagSpecId: string, tagName: string): OptionType {
    const meta = sourceMeta(tagName);

    return {
        value: tagSpecId,
        label: tagName,
        iconNode: <GoTag size={13} />,
        tone: meta.tone,
    };
}
